import { Check, ChevronsUpDown } from 'lucide-react'
import * as React from 'react'
import { cn } from '@/lib/utils'
import { Button } from '@/view/components/ui/button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/view/components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/view/components/ui/popover'


const mock = [
  {
    value: 'teste',
    label: 'teste'
  }
]

interface PropsComboBox {
  className?: string
  placeholder?: string
  searchStringPlaceholder?: string
  defaultValue?: any
  onChange?: (data: any) => void
  setFormValue?: (data: any, value?: any) => void
  formName?: string
  data?: {
    value: any
    label: string
  }[]
  field?: any
}

export function ComboSelect({ className, placeholder = 'Selecione...', searchStringPlaceholder = 'Pesquise...', defaultValue = '', onChange, setFormValue, formName = '', data = mock }: PropsComboBox) {
  const [open, setOpen] = React.useState(false)
  const [value, setValue] = React.useState(defaultValue)
  const [searchTerm, setSearchTerm] = React.useState('');

  React.useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const handleSelect = (currentValue: any) => {
    const newValue = currentValue === value ? '' : currentValue
    setValue(newValue)
    setOpen(false)
    if (onChange) {
      onChange(newValue)
    }
  }

  React.useEffect(() => {
    if (setFormValue) {
      setFormValue(formName, searchTerm)
    }
  }, [searchTerm])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild className={className}>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between">
          {value ? data.find((item) => item.value === value)?.label : placeholder}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Command>
          <CommandInput
            placeholder={searchStringPlaceholder}
            onValueChange={(value) => setSearchTerm(value)}
          />
          <CommandList>
            <CommandEmpty>Sem dados.</CommandEmpty>
            <CommandGroup>
              {data.map((item) => (
                <CommandItem
                  key={item.value}
                  value={item.value}
                  onSelect={() => handleSelect(item.value)}
                  keywords={[item.label]}
                >
                  <Check className={cn('mr-2 h-4 w-4', value === item.value ? 'opacity-100' : 'opacity-0')} />
                  {item.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
